import React from 'react';
import {AnalysisComponent} from './analysisComponent';
import {useTranslation} from 'react-i18next';
import {SearchPageType} from '../search/search-config';
import {DefaultRootState, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

export const AnalysisPage = React.memo(() => {
    const analysisConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.analysis);
    const navigate = useNavigate();
    if (!analysisConfig.enabled) {
        navigate('/');
    }
    const searchPageType = SearchPageType.BASIC;
    const {t} = useTranslation();

    return (
        <AnalysisComponent
            inputTitle={t('analysis.input.title')}
            resultsTitle={t('analysis.results.title')}
            searchPageType={searchPageType}
        />
    );
});
